<div
  class="preclinical flex flex-col w-full bg-background-tertiary"
  [class.expanded-view]="isExpanded"
  [class.gap-6]="!isExpanded"
  [class.py-6]="!isExpanded"
  [class.min-h-screen]="!isExpanded"
  [class.h-screen]="isExpanded"
  [class.p-0]="isExpanded"
>
  <div
    class="header-section flex flex-col"
    [class.gap-6]="!isExpanded"
    [class.px-8]="isExpanded"
    [class.py-6]="isExpanded"
    [class.gap-3]="isExpanded"
  >
    <div class="flex flex-col gap-2">
      <h3 class="text-2xl font-bold text-brand-tertiary m-0">Preingresos</h3>
      <p class="text-sm text-text-secondary m-0">
        Previsualiza las muestras ingresadas para validar que su registro esté
        correcto.
      </p>
      <p class="text-sm text-text-secondary m-0">
        Una vez guardado, solo lo podrá editar el administrador.
      </p>
    </div>

    @if (!isExpanded) {
      <app-metrics-dashboard [metrics]="dashboardMetrics">
      </app-metrics-dashboard>
    }

    <div class="flex flex-col gap-4">
      <div class="flex justify-between items-center gap-4 flex-wrap">
        <div class="flex gap-4">
          <app-button
            label="Filtrar"
            leftIcon="icon-filtro"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleFilterSidebar()"
          >
          </app-button>
          <app-button
            label="Buscar"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleSearchControls()"
          >
          </app-button>
          <app-button
            label="Inmovilizar"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleFrozenColumnsSidebar()"
          >
          </app-button>
        </div>

        <button
          (click)="toggleExpansion()"
          class="w-10 h-10 min-w-10 min-h-10 border-none bg-transparent cursor-pointer p-0 flex-shrink-0"
          [class.icon-expandir-vista]="!isExpanded"
          [class.icon-contraer-vista]="isExpanded"
          [attr.aria-label]="isExpanded ? 'Contraer vista' : 'Expandir vista'"
          type="button"
        ></button>
      </div>

      @if (showSearchControls()) {
        <div class="search-controls-container animate-fade-in">
          <app-search-controls
            [searchFieldOptions]="searchFieldOptions"
            (searchExecuted)="handleSearch($event)"
            (clear)="handleClearSearch()"
          ></app-search-controls>
        </div>
      }

      @if (hasActiveFilters) {
        <app-active-filters
          [filterCriteria]="currentFilterCriteria"
          (clearFilters)="clearFilters()"
        ></app-active-filters>
      }
    </div>
  </div>

  <div
    class="flex flex-col table-container min-h-0"
    [class.flex-1]="isExpanded"
    [class.overflow-hidden]="isExpanded"
  >
    <app-table
      [items]="orders"
      [visibleColumns]="visibleColumnsComputed()"
      [frozenColumns]="frozenColumnsInOrder()"
      [tableName]="'Preingresos'"
      [tableActions]="tableActions"
      [showCheckboxes]="true"
      [itemIdField]="'id'"
      [selectedIds]="selectedOrderIds()"
      (selectionChange)="handleSelectionChange($event)"
    >
    </app-table>

    @if (hasSelectedOrders()) {
      <div
        class="flex justify-between items-center px-8 py-3 bg-blue-50 border-t border-blue-200"
      >
        <div class="flex items-center gap-2">
          <i class="icon-check-circle text-blue-600"></i>
          <span class="text-sm font-medium text-blue-900">
            {{ selectedCount() }} de {{ totalRecords }} muestras seleccionadas
          </span>
        </div>
        <button
          type="button"
          class="text-sm text-blue-600 hover:text-blue-800 underline cursor-pointer bg-transparent border-none"
          (click)="clearSelections()"
        >
          Limpiar selección
        </button>
      </div>
    }

    <app-paginator
      [totalRegister]="totalRecords"
      (getData)="onPageChange($event)"
    >
    </app-paginator>

    <div class="flex justify-end px-8 py-4">
      <app-button
        label="Guardar definitivo"
        [type]="ButtonTypeEnum.PRIMARY"
        [size]="ButtonSizeEnum.MD"
        [disabled]="!hasSelectedOrders() || isProcessing()"
        (handleClick)="handleFinalSave()"
      >
      </app-button>
    </div>
  </div>
</div>

<app-frozen-columns-sidebar
  [columns]="availableColumns"
  [isOpen]="isFrozenSidebarOpen"
  (closeSidebar)="closeFrozenColumnsSidebar()"
>
</app-frozen-columns-sidebar>

<app-filter-sidebar
  [isOpen]="isFilterSidebarOpen"
  [hiddenFilters]="['region', 'site', 'dateRange', 'sampleStatus', 'sampleType', 'facility']"
  [filterOptionsService]="getFilterOptionsService()"
  [currentFilters]="currentFilterCriteria"
  (closeSidebar)="closeFilterSidebar()"
  (applyFilters)="handleApplyFilters($event)"
>
</app-filter-sidebar>

<app-floating-sidebar
  [isOpen]="showEditSampleModal()"
  [title]="'Editar muestra'"
  [width]="'70%'"
  (closePanel)="closeEditSampleModal()"
>
  @if (showEditSampleModal() && editSampleData()) {
    <app-edit-sample-tabs
      [editData]="editSampleData()!"
      [caseNumber]="editCaseNumber()!"
      (saveSuccess)="handleEditSuccess()"
      (cancelEdit)="closeEditSampleModal()"
    ></app-edit-sample-tabs>
  }
  @if (showEditSampleModal() && !editSampleData()) {
    <div class="flex items-center justify-center p-8">
      <p class="text-gray-500">Cargando datos...</p>
    </div>
  }
</app-floating-sidebar>

<app-toast></app-toast>

<app-final-save-modal
  [isOpen]="finalSaveModalOpen()"
  [state]="finalSaveModalState()"
  [selectedCount]="selectedCount()"
  [selectedSamples]="selectedOrders"
  [response]="finalSaveResponse()"
  (confirm)="onFinalSaveModalConfirm()"
  (closeModal)="onFinalSaveModalClose()"
>
</app-final-save-modal>

@if (showDeleteConfirmModal()) {
  <app-generic-modal
    [imageSrc]="'assets/images/delete-confirmation.svg'"
    [title]="'¿Quieres eliminar la muestra?'"
    [boldText]="
      'Al eliminar la muestra ingresada, no podrás recuperarla de nuevo,'
    "
    [description]="'¿estás seguro de esta acción?'"
    [noText]="'Cancelar'"
    [yesText]="'Eliminar'"
    (closeModal)="closeDeleteModal()"
    (confirm)="onConfirmDelete()"
  >
  </app-generic-modal>
}
